import { jsx as _jsx } from "react/jsx-runtime";
import { _className, Grid } from '@nu-art/thunderstorm-frontend/index';
import './Component_DataGrid.scss';
const _DataGrid = (props) => {
    const className = _className('quai-manager-ui__data-grid', props.className);
    return _jsx(Grid, { className: className, children: props.children });
};
const DataGridLabel = (props) => {
    const className = _className('quai-manager-ui__data-grid__label', props.className);
    return _jsx("div", { className: className, onClick: props.onClick, children: props.children });
};
const DataGridData = (props) => {
    const className = _className('quai-manager-ui__data-grid__data', props.className);
    return _jsx("div", { className: className, onClick: props.onClick, children: props.children });
};
export const DataGrid = {
    Grid: _DataGrid,
    Label: DataGridLabel,
    Data: DataGridData,
};
//# sourceMappingURL=Component_DataGrid.js.map